<div class="help-side-drawer-container">
  <mat-toolbar class="help-side-drawer-toolbar">
    <mat-toolbar-row>
      <div class="help-side-drawer-pre-title-actions">
        <ng-content select="app-help-side-drawer-pre-title-actions"></ng-content>
      </div>
      <h1 class="help-side-drawer-toolbar-title">{{ title }}</h1>
      <div class="help-side-drawer-title-actions">
        <ng-content select="app-help-side-drawer-title-actions"></ng-content>
      </div>
      <ng-container>
        <button mat-icon-button *ngIf="!preventClose" (click)="closeSideDrawer()">
          <mat-icon>close</mat-icon>
        </button>
      </ng-container>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="help-side-drawer-content">
    <ng-content select="app-help-side-drawer-content"></ng-content>
  </div>

  <footer class="help-side-drawer-footer">
    <ng-content select="app-help-side-drawer-footer"></ng-content>
  </footer>
</div>
